import React from "react";

const GunMan = () => {
  return (
    <div className="gunman h-[400px] flex justify-center items-center">
      <h1 className="text-2xl text-center md:text-5xl lg:text-7xl xl:text-8xl">
        Capital. Tech. Vision.
      </h1>
    </div>
  );
};

export default GunMan;
